module.exports = __webpack_public_path__ + "media/images/mobile/solutions/bg25-a91cc105c361749d0a49547cd4bcbcc4.png";